import { post, get } from "./http"

const customer = {
    // 用户端
    // 提交实名认证
    identitySub(params) {
        return post(api + "client/identity", params)
    },
    // 获取认证资料
    Getidentity() {
        return get(api + "client/identity")
    },
}

export default customer